(function (angular) {
    angular.module('bizPartEngage').controller('core.themestest', themestestController);

    themestestController.$inject = [];

    function themestestController() {
        var vm = this;

        vm.Init = Init;

        function Init() {
            console.log('ThemesTest init...')
        }

        vm.$onInit = Init;
    }
}(window.angular));